import { render, staticRenderFns } from "./PRF301P02.vue?vue&type=template&id=2b95c1c7&"
import script from "./PRF301P02.vue?vue&type=script&lang=js&"
export * from "./PRF301P02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports